import React from 'react'
import { GoArrowDownRight } from 'react-icons/go'

export default function DeepWhalesAI() {
  return (
    <div
      class='w-full relative '
      id='premiumservices'
    >
      <section class='w-full left-0 md:max-w-[90%]  mx-auto py-10 relative px-5 flex flex-col justify-center items-center gap-4'>
        <div className='box px-8 font-medium py-1.5 rounded-full text-[#DBA200] text-xl  animate__fadeInDown animate__animated wow'>
          Features
        </div>
        <h1 className='md:text-5xl text-4xl text-center animate__slideInUp animate__animated wow'>
          Deep Whales AI <br /> Apps
        </h1>
        <div className='grid md:grid-cols-2 grid-cols-1 mt-10 md:gap-20 gap-10'>
          <div className='space-y-4 flex flex-col justify-center items-center'>
            <img
              src='/images/mobile-1.png'
              alt='mobile'
              className='h-full max-h-[500px] upanddown'
            />
            <h2 className='flex items-center lg:text-3xl text-2xl animate__slideInUp animate__animated wow'>
              DeepWhales AI <p>(App)</p>
            </h2>
          </div>
          <div className='space-y-4 flex flex-col justify-center items-center'>
            <img
              src='/images/mobile-2.png'
              alt='mobile'
              className='h-full max-h-[500px] upanddown'
            />
            <h2 className='flex items-center lg:text-3xl text-2xl animate__slideInUp animate__animated wow'>
              DeepWhales AI <p>(Telegram Bot)</p>
            </h2>
          </div>
        </div>
      </section>
    </div>
  )
}
